var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "omni-alert omni-alert-inline"
  }, [_c('BAlert', _vm._b({}, 'BAlert', [_vm.$attrs, _vm.$props], false), [_c('span', {
    staticClass: "icon mr-2"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": _vm.iconToShow
    }
  })], 1), _c('span', {
    staticClass: "message"
  }, [_vm._t("default", function () {
    return [_vm._v(" " + _vm._s(_vm.message) + " ")];
  })], 2)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }